import React, { Component } from 'react';
import { InputGroup, Row, Col, Table, Image } from 'react-bootstrap';
import NumericTextboxComponent from 'react-numeric-textbox';

export default class TPZType2 extends Component {
    constructor() {
        super();

        this.state = {
            distanceA: 0,
            distanceB: 0,
            tpzradius: 0,
            tpzarea: 0,
            srz: 0,
            distreq: 0,
            perclost: 0,
        }

        this.updateDistanceA = this.updateDistanceA.bind(this)
        this.updateDistanceB = this.updateDistanceB.bind(this)
        this.calcEncroachmentArea = this.calcEncroachmentArea.bind(this)
        this.calcEncroachmentPercentage = this.calcEncroachmentPercentage.bind(this)
        this.getEncoachmentPercentage = this.getEncoachmentPercentage.bind(this)
    }

    componentDidMount = () => {
        console.log(this.props)

        this.setState({
            tpzradius: this.props.tpzradius,
            tpzarea: this.props.tpzarea,
            srz: this.props.srz
        })
    }

    updateDistanceA = (e) => {
        var distance = Number(e)

        this.setState({
            distanceA: distance
        })
    }

    updateDistanceB = (e) => {
        var distance = Number(e)

        this.setState({
            distanceB: distance
        })
    }

    calcEncroachmentArea = () => {
        var r = this.props.tpzradius
        var A = this.state.distanceA
        var B = this.state.distanceB
        var area_triangle = (this.state.distanceA * this.state.distanceB) / 2
        var C = Math.sqrt(Math.pow(A, 2) + Math.pow(B, 2))
        var h = r - Math.sqrt(Math.pow(r, 2) - Math.pow(C / 2, 2))
        var area = Math.pow(r, 2) * Math.acos((r - h) / r) - (r - h) * Math.sqrt(2 * r * h - Math.pow(h, 2))
        return (area + area_triangle);
    }

    calcEncroachmentPercentage = () => {
        var perclost = this.calcEncroachmentArea() / this.props.tpzarea
        return perclost * 100;
    }

    getEncoachmentPercentage = () => {
        var color = "black"
        var perc = this.calcEncroachmentPercentage().toFixed(1)

        if (perc > 50) {
            return (
                <div style={{ color: "red" }}>
                    &gt;50
                </div>
            )
        }
        else if (perc >= 10) {
            color = "red"
        } else {
            color = "orange"
        }

        return (
            <div style={{ color: color }}>
                {perc}
            </div>
        )
    }

    getEncoachmentLevel = () => {
        var color = "black"
        var perc = this.calcEncroachmentPercentage().toFixed(1)
        var level = ""

        if (perc >= 20) {
            color = "red"
            level = "Major"
        } else if (perc >= 10) {
            color = "red"
            level = "Moderate"
        } else {
            color = "orange"
            level = "Minor"
        }

        if (this.state.distance > this.props.tpzradius) {
            return (
                <div style={{ color: "#71b832" }}>
                    Works outside NRZ
                </div>
            )
        } else {
            return (
                <div style={{ color: color }}>
                    {level}
                </div>
            )
        }
    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={{ order: 12 }} sm={{ order: 12 }}>
                        <label>Enter the length (m) of both corner sides for works within NRZ.</label>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text id="basic-addon1">B</InputGroup.Text>
                            </InputGroup.Prepend>
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateDistanceA}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">m</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text id="basic-addon1">C</InputGroup.Text>
                            </InputGroup.Prepend>
                            <NumericTextboxComponent
                                className="form-control"
                                min={0}
                                decimals={1}
                                value={0}
                                format={'0.0'}
                                onChange={this.updateDistanceB}
                                autoCorrect={true}
                            />
                            <InputGroup.Append>
                                <InputGroup.Text id="basic-addon2">m</InputGroup.Text>
                            </InputGroup.Append>
                        </InputGroup>
                        <Table responsive>
                            <tbody>
                                <tr>
                                    <td>NRZ radius (m)</td>
                                    <td class="text-right">{this.props.tpzradius.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>SRZ radius (m)</td>
                                    <td class="text-right">{this.props.srz.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>NRZ area (m²)</td>
                                    <td class="text-right">{this.props.tpzarea.toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment area (m²)</td>
                                    <td class="text-right">{this.calcEncroachmentArea().toFixed(1)}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment (%)</td>
                                    <td class="text-right">{this.getEncoachmentPercentage()}</td>
                                </tr>
                                <tr>
                                    <td>Encroachment Level</td>
                                    <td class="text-right">{this.getEncoachmentLevel()}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                    <Col xs={{ span: 12, order: 'first' }} sm={{ span: 12, order: 'first' }} md={{ span: 4, order: 12 }} lg={{ span: 4, order: 12 }}>
                        <Image src="https://storage.googleapis.com/as4970-2025/NRZ_encroachment_type_B_graphic.png" height="250" />
                        <p>
                            <small>
                                Encroachment Type B: Works intersecting along two perpendicular straight edges (corner).<sup>2</sup>
                            </small>
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={{ span: 2, order: 'last' }} lg={{ span: 2, order: 'last' }}></Col>
                </Row>
            </div>
        )
    }
}